import {useOperator} from "../context/OperatorContext";
import {OperatorSubdomain} from "../types/Operator";
import {developmentOperators} from "../services/operator";
import {useMemo} from "react";

// Custom hook

export function useIsCurrentOperatorAllowed(allowedOperators: OperatorSubdomain[] = []) {
  // Get current operator subdomain
  const {subdomain} = useOperator();

  // Combine allowed operators with development operators and staging (test-operator)
  const allAllowedOperators = useMemo(
    (): OperatorSubdomain[] => [...allowedOperators, ...developmentOperators, 'test-operator'],
    [allowedOperators]
  );

  // Bail if we don't have the current operator subdomain
  if (!subdomain) return false;

  return allAllowedOperators.includes(subdomain);
}